import { render, staticRenderFns } from "./customFieldsInPR.vue?vue&type=template&id=6bf6e2c3&"
import script from "./customFieldsInPR.vue?vue&type=script&lang=js&"
export * from "./customFieldsInPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports